import React from "react";
import { motion } from "framer-motion";
import { BiSortAlt2 } from "react-icons/bi";

function SortButton({ openModal }) {
  return (
    <motion.button
      className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded flex items-center"
      onClick={openModal}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <BiSortAlt2 className="mr-2" /> Sort Projects
    </motion.button>
  );
}

export default SortButton;